import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHashHistory(), // hash模式：createWebHashHistory，history模式：createWebHistory
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        left: 0,
        top: 0
      }
    }
  },
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/index.vue'),
    },
    {
      path: '/index',
      name: 'index',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/index.vue'),
    },
    {
      path: '/list',
      name: 'list',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/list.vue'),
    },
    {
      path: '/detail',
      name: 'detail',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/detail.vue'),
    },
    {
      path: '/mainData',
      name: 'mainData',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/mainData.vue'),
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/aboutUs.vue'),
    },
    {
      path: '/BIreport',
      name: 'BIreport',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/BIreport.vue'),
    },
    {
      path: '/integrationOf',
      name: 'integrationOf',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/integrationOf.vue'),
    },
    {
      path: '/regionalOptimization',
      name: 'regionalOptimization',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/regionalOptimization.vue'),
    },
    {
      path: '/wisdomToVisit',
      name: 'wisdomToVisit',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/wisdomToVisit.vue'),
    },
    {
      path: '/intelligentClassification',
      name: 'intelligentClassification',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/intelligentClassification.vue'),
    },
    {
      path: '/intelligentScheduling',
      name: 'intelligentScheduling',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/intelligentScheduling.vue'),
    },
    {
      path: '/flowManagement',
      name: 'flowManagement',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/flowManagement.vue'),
    },
    {
      path: '/solution',
      name: 'solution',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/solution.vue'),
    },
    {
      path: '/CRM',
      name: 'CRM',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/CRM.vue'),
    },
    {
      path: '/pharmacistOperation',
      name: 'pharmacistOperation',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/pharmacistOperation.vue'),
    },
    {
      path: '/costManagement',
      name: 'costManagement',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/costManagement.vue'),
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/privacy.vue'),
    },
  ]
})

export default router